<!--COMPACT MODE! - WIDOK NA LISCIE SPLITVIEW OBOK DETALI-->
@if (isMobile() && mobileCompact()) {
  <!-- PROPOZYCJA — DO WERYFIKACJI: mobile density of the existing recursive list. -->
  <div
    [class.mobile-task-tree--expanded]="isExpanded()"
    [class.mobile-task-tree--root]="!isSubtask()"
    [class.mobile-task-tree--subtask]="isSubtask()"
    [class.mobile-task-tree--no-status]="!mobileStatusVisible()"
    [style.--mobile-task-indent.px]="mobileIndent()"
    class="mobile-task-tree"
  >
    <div class="mobile-task-row">
      @if (mobileStatusVisible()) {
        <proffeo-ui-status-badge
          [status]="task().status"
          [showLabel]="false"
          mode="dot"
          class="mobile-task-status"
        />
      }
      <button
        (click)="onTaskClick()"
        type="button"
        class="mobile-task-content"
      >
        <span class="mobile-task-title-line">
          <span class="mobile-task-title">{{ task().name }}</span>
          @if (mobilePriorityVisible() && task().priority !== TaskPriority.NORMAL) {
            <proffeo-ui-priority-badge [priority]="task().priority" />
          }
        </span>
      </button>
      @if (hasChildren() || isExpanded()) {
        <button
          (click)="toggleSubtasks($event)"
          [attr.aria-controls]="taskChildrenId()"
          [attr.aria-expanded]="isExpanded()"
          [attr.aria-label]="('tasks-list-name-column-show-subtasks' | translate) + ': ' + task().name"
          type="button"
          class="mobile-task-children-toggle"
        >
          <span class="mobile-task-chevron-slot">
            <mat-icon
              [fontIcon]="isExpanded() ? 'expand_more' : 'chevron_right'"
              class="icon-md"
            />
          </span>
          <span class="mobile-task-count">{{ task().subtasksCount }}</span>
        </button>
      } @else if (isSubtask()) {
        <mat-icon
          fontIcon="subdirectory_arrow_right"
          class="mobile-task-leaf icon-sm"
        />
      }
      <button
        (click)="onTaskClick()"
        type="button"
        class="mobile-task-meta"
      >
        <span class="mobile-task-identifier">
          {{ task().taskType().code + '-' + task().taskNumber }}
          @if (locationDisplayPath()) {
            · {{ locationDisplayPath() }}
          }
        </span>
        @if (mobileDateMode() !== 'none') {
          <span
            [attr.aria-label]="mobileDateLabelKey() | translate"
            class="mobile-task-date"
          >
            {{ visibleMobileDate() ? (visibleMobileDate() | date: 'dd.MM.yy') : '—' }}
          </span>
        }
      </button>
      <div class="mobile-task-aside">
        @if (mobileAvatarMode() === 'task' && avatarUrl() && !imgError()) {
          <img
            (click)="onTaskClick()"
            (error)="onAvatarError()"
            [src]="avatarUrl()"
            alt=""
            class="mobile-task-avatar"
          />
        } @else if (mobileAvatarMode() === 'participants' && participantUsers().length > 0) {
          <button
            (click)="onTaskClick()"
            [attr.aria-label]="('project-tasks.list.column-headers.participants' | translate) + ': ' + task().name"
            type="button"
            class="mobile-task-participants"
          >
            <proffeo-group-avatars
              [groupUsers]="participantUsers()"
              [avatarSize]="AvatarSize.XS"
              [showAvatarsCount]="2"
              [showMore]="false"
            />
          </button>
        }
        <proffeo-task-row-actions-menu
          [task]="task()"
          class="mobile-task-actions"
        />
      </div>
    </div>
    @if (shouldRenderChildren()) {
      <div
        [id]="taskChildrenId()"
        class="mobile-task-children"
      >
        @if (childrenStatus() === 'loading') {
          <p
            role="status"
            class="px-2 py-2"
          >
            {{ 'loading-tasks' | translate }}
          </p>
        } @else if (childrenStatus() === 'error') {
          <div class="flex items-center gap-2 px-2 py-2">
            <p role="alert">{{ 'task-tree-load-error' | translate }}</p>
            <proffeo-ui-button
              (clicked)="retryChildren()"
              text="task-tree-retry"
              size="sm"
            />
          </div>
        }
        @for (sub of subtasks(); track sub.id) {
          <proffeo-task-splitview-list-item
            [(expandedNodes)]="expandedNodes"
            [task]="sub"
            [isSubtask]="true"
            [mobileCompact]="mobileCompact()"
            [subtaskDepth]="subtaskDepth() + 1"
            [hasChildren]="(sub.subtasksCount ?? 0) > 0"
            [taskTypes]="taskTypes()"
          />
        }
      </div>
    }
  </div>
} @else if (compactMode()) {
  <div class="flex w-full flex-col">
    <div class="flex w-full items-stretch">
      @if (isSubtask()) {
        <div
          [style.min-width]="calculatedIndentWidth()"
          [style.width]="calculatedIndentWidth()"
          class="flex shrink-0 items-center justify-end"
        >
          <mat-icon
            fontIcon="subdirectory_arrow_right"
            class="opacity-50 icon-xs"
          />
        </div>
      }
      <div
        (click)="onTaskClick()"
        [class]="cardStatusBorder() + ' relative min-w-0 flex-1 cursor-pointer items-center gap-3 p-2 shadow-sm'"
        [class.border-active]="isSelected()"
        [class.border-hover]="!isSelected()"
        [class.bg-proffeo-surface]="!isSelected()"
        [class.task-list-item--active]="isSelected()"
        [class.font-bold]="isSelected()"
      >
        <div class="flex w-full flex-col gap-2 pr-1">
          <div class="flex w-full gap-2 justify-between">
            <p
              [class.font-bold]="isSelected()"
              [class.font-medium]="!isSelected()"
              class="min-w-0 line-clamp-2 break-words"
            >
              {{ task().name }}
            </p>
            <div class="flex shrink-0 gap-0">
              @if ((!isMobile() || mobilePriorityVisible()) && task().priority !== TaskPriority.NORMAL) {
                <proffeo-task-priority-select
                  (click)="$event.stopPropagation()"
                  (prioritySelected)="priorityChanged.emit({ priority: $event, task: task() })"
                  [taskPriority]="task().priority"
                  [readonly]="false"
                  [small]="true"
                ></proffeo-task-priority-select>
              }
              @if (isMobile() && mobileDateMode() !== 'none') {
                <span
                  [attr.aria-label]="mobileDateLabelKey() | translate"
                  class="text-sm"
                >
                  {{ visibleMobileDate() ? (visibleMobileDate() | date: 'dd.MM.yy') : '—' }}
                </span>
              }
              <span class="text-sm no-wrap">{{ task().taskType().code + '-' + task().taskNumber }}</span>
              <proffeo-task-row-actions-menu [task]="task()" />
            </div>
          </div>
          <div class="flex w-full gap-2 justify-between"></div>

          <div class="mt-auto flex min-w-0 items-end gap-1">
            <div class="flex min-w-0 w-full flex-1 flex-col gap-1">
              @if (locationDisplayPath()) {
                <div class="flex min-w-0 w-full items-center gap-1 overflow-hidden">
                  <mat-icon
                    fontIcon="location_on"
                    class="shrink-0 opacity-50 icon-md"
                  />
                  <p class="min-w-0 flex-1 truncate text-sm">{{ locationDisplayPath() }}</p>
                </div>
              }
              <div class="flex items-center gap-1">
                @if (hasChildren() || isExpanded()) {
                  <button
                    (click)="toggleSubtasks($event)"
                    [attr.aria-expanded]="isExpanded()"
                    [class.proffeo-ui-tree-count-chip-active]="isExpanded()"
                    type="button"
                    class="proffeo-ui-tree-count-chip w-fit self-end"
                  >
                    <mat-icon
                      fontIcon="subdirectory_arrow_right"
                      class="icon-sm opacity-50"
                    />
                    <span>{{ task().subtasksCount }}</span>
                  </button>
                }
                @if (industryName()) {
                  <div class="flex items-center gap-1 overflow-hidden">
                    <mat-icon
                      fontIcon="business_center"
                      class="shrink-0 opacity-50 icon-md"
                    />
                    <p class="min-w-0 flex-1 truncate text-sm">{{ industryName() }}</p>
                  </div>
                }
              </div>
            </div>
            @if (isMobile() && mobileAvatarMode() === 'participants' && participantUsers().length > 0) {
              <proffeo-group-avatars
                [groupUsers]="participantUsers()"
                [avatarSize]="AvatarSize.XS"
                [showAvatarsCount]="2"
                [showMore]="false"
                class="ml-auto shrink-0"
              />
            } @else if (isMobile() && mobileAvatarMode() === 'task' && avatarUrl() && !imgError()) {
              <img
                (error)="imgError.set(true)"
                [src]="avatarUrl()"
                class="ml-auto size-12 shrink-0 self-start object-cover"
              />
            } @else if (!isMobile() && avatarUrl() && !imgError()) {
              <img
                (error)="imgError.set(true)"
                [src]="avatarUrl()"
                class="ml-auto hidden size-12 shrink-0 self-start object-cover lg:block"
              />
            }
          </div>
        </div>
      </div>
    </div>

    @if (shouldRenderChildren()) {
      <div class="flex flex-col gap-3 lg:gap-2 w-full mt-2 lg:mt-1">
        @for (sub of subtasks(); track sub.id) {
          <proffeo-task-splitview-list-item
            [(expandedNodes)]="expandedNodes"
            (statusChanged)="statusChanged.emit($event)"
            (priorityChanged)="priorityChanged.emit($event)"
            (taskStartDateSelected)="taskStartDateSelected.emit($event)"
            (taskEndDateSelected)="taskEndDateSelected.emit($event)"
            (taskProgressSelected)="taskProgressSelected.emit($event)"
            (industryClicked)="industryClicked.emit($event)"
            (locationClicked)="locationClicked.emit($event)"
            (changeGroupClicked)="changeGroupClicked.emit($event)"
            (changeUsersClicked)="changeUsersClicked.emit($event)"
            [task]="sub"
            [isSubtask]="true"
            [subtaskDepth]="subtaskDepth() + 1"
            [compactMode]="true"
            [hasChildren]="(sub.subtasksCount ?? 0) > 0"
            [taskTypes]="taskTypes()"
            class="w-full"
          ></proffeo-task-splitview-list-item>
        }
      </div>
    }
  </div>
} @else {
  <!-- DESKTOP / RESPONSYWKA PELNEJ LISTY -->

  <div class="flex flex-col gap-2 lg:gap-2 rounded-md">
    <div class="flex w-full group">
      @if (isSubtask()) {
        <div
          [style.min-width]="calculatedIndentWidth()"
          [style.width]="calculatedIndentWidth()"
          class="flex shrink-0 items-center justify-end"
        >
          <mat-icon
            fontIcon="subdirectory_arrow_right"
            class="opacity-50 icon-xs"
          />
        </div>
      }
      <button
        (click)="onTaskClick()"
        [class]="cardStatusBorder() + ' flex w-full border-hover duration-500 rounded-md'"
      >
        <div class="flex p-2 bg-proffeo-surface max-sm:hidden max-w-[90%]">
          @if (!imgError()) {
            <img
              (error)="imgError.set(true)"
              [src]="avatarUrl()"
              class="object-cover h-full aspect-square min-w-20 max-w-20"
            />
          } @else {
            <div
              class="flex h-full min-w-20 max-w-20 items-center justify-center rounded-l-md bg-proffeo-surface-muted"
            >
              <mat-icon
                fontIcon="photo_camera"
                class="icon-xl icon-disabled"
              />
            </div>
          }
        </div>
        <div
          class="py-2 px-3 grid gap-2.5 grid-cols-1 h-full items-center bg-proffeo-surface w-full md:rounded-l-none! cursor-pointer rounded-md sm:grid-cols-[minmax(0,1fr)_85px_85px_24px] md:grid-cols-[minmax(0,1fr)_60px_70px_110px_85px_24px] lg:grid-cols-[minmax(0,1fr)_70px_80px_110px_80px_90px_90px_24px] xl:grid-cols-[minmax(0,1fr)_90px_70px_130px_110px_80px_90px_90px_24px]"
        >
          <div class="flex min-w-0 flex-col gap-1.5 w-full">
            <div class="flex gap-2 justify-between items-center">
              <!--            TYTUŁ-->
              <p class="min-w-0 flex-1 truncate text-start">
                {{ task().name }}
              </p>
              <p class="font-light text-xs hidden whitespace-nowrap max-sm:block">
                {{ task().taskType().code + '-' + task().taskNumber }}
              </p>
            </div>

            <div class="flex w-full truncate gap-1">
              @for (tag of tags(); track tag) {
                <proffeo-tag
                  [tag]="tag"
                  class="max-sm:hidden"
                ></proffeo-tag>
              }
            </div>
            <div class="flex items-center gap-3 flex-wrap">
              @if (!isMobile()) {
                @if (task().subtasksCount > 0 || isExpanded()) {
                  <button
                    (click)="toggleSubtasks($event)"
                    [attr.aria-expanded]="isExpanded()"
                    [class.proffeo-ui-tree-count-chip-active]="isExpanded()"
                    type="button"
                    class="proffeo-ui-tree-count-chip"
                  >
                    <mat-icon
                      fontIcon="subdirectory_arrow_right"
                      class="icon-sm opacity-50"
                    />
                    <span>{{ task().subtasksCount }}</span>
                  </button>
                }
                <proffeo-task-status-select
                  (click)="$event.stopPropagation()"
                  (statusSelected)="statusChanged.emit({ status: $event, task: task() })"
                  [mode]="TaskStatusSelectEnum.DOTS"
                  [taskStatus]="task().status"
                  [small]="true"
                  [readonly]="false"
                ></proffeo-task-status-select>
                @if (task().priority !== TaskPriority.NORMAL) {
                  <proffeo-task-priority-select
                    (click)="$event.stopPropagation()"
                    (prioritySelected)="priorityChanged.emit({ priority: $event, task: task() })"
                    [taskPriority]="task().priority"
                    [readonly]="true"
                  ></proffeo-task-priority-select>
                }
                <div class="flex items-center gap-1">
                  <proffeo-task-type-select
                    [small]="true"
                    [readonly]="true"
                    [activeTaskType]="task().taskType()"
                    [taskTypes]="taskTypes()"
                    [taskNumber]="task().taskNumber"
                  ></proffeo-task-type-select>
                </div>
              }
              <div class="hidden max-sm:flex justify-between gap-4 w-full">
                <p class="line-clamp-2 text-left text-xs font-light">
                  {{ task().description | formatHtmlToText }}
                </p>

                @if (mobileAvatarMode() === 'task') {
                  <div>
                    @if (!imgError()) {
                      <img
                        (error)="imgError.set(true)"
                        [src]="avatarUrl()"
                        class="object-cover h-full aspect-square max-w-12"
                      />
                    } @else {
                      <div class="flex h-full min-w-12 min-h-12 items-center justify-center bg-proffeo-surface-muted">
                        <mat-icon
                          fontIcon="photo_camera"
                          class="icon-xl icon-disabled"
                        />
                      </div>
                    }
                  </div>
                } @else if (mobileAvatarMode() === 'participants' && participantUsers().length > 0) {
                  <proffeo-group-avatars
                    [groupUsers]="participantUsers()"
                    [avatarSize]="AvatarSize.XS"
                    [showAvatarsCount]="2"
                    [showMore]="false"
                  />
                }
              </div>
            </div>
            <div class="hidden max-sm:flex justify-between w-full gap-2 my-2">
              <div class="flex gap-2">
                <div class="flex gap-2 items-center flex-wrap">
                  @if (task().subtasksCount > 0 || isExpanded()) {
                    <button
                      (click)="toggleSubtasks($event)"
                      [attr.aria-expanded]="isExpanded()"
                      [class.proffeo-ui-tree-count-chip-active]="isExpanded()"
                      type="button"
                      class="proffeo-ui-tree-count-chip"
                    >
                      <mat-icon
                        fontIcon="subdirectory_arrow_right"
                        class="icon-sm opacity-50"
                      />
                      <span>{{ task().subtasksCount }}</span>
                    </button>
                  }

                  @if (mobileStatusVisible()) {
                    <div>
                      <proffeo-task-status-select
                        (click)="$event.stopPropagation()"
                        (statusSelected)="statusChanged.emit({ status: $event, task: task() })"
                        [mode]="TaskStatusSelectEnum.DOTS"
                        [taskStatus]="task().status"
                        [small]="true"
                        [readonly]="true"
                      ></proffeo-task-status-select>
                    </div>
                  }

                  @if (task().location?.()?.name) {
                    <div class="max-sm:flex hidden min-w-0 w-full basis-full items-center gap-1">
                      <mat-icon
                        fontIcon="location_on"
                        class="shrink-0 opacity-50 icon-sm"
                      />
                      <span class="min-w-0 flex-1 truncate text-sm text-start">
                        {{ task().location().name }}
                      </span>
                    </div>
                  }
                </div>
              </div>
              <div class="flex gap-2">
                @if (mobilePriorityVisible() && task().priority !== TaskPriority.NORMAL) {
                  <proffeo-task-priority-select
                    (click)="$event.stopPropagation()"
                    (prioritySelected)="priorityChanged.emit({ priority: $event, task: task() })"
                    [taskPriority]="task().priority"
                    [readonly]="true"
                  ></proffeo-task-priority-select>
                }
                @if (mobileDateMode() !== 'none') {
                  <span
                    [attr.aria-label]="mobileDateLabelKey() | translate"
                    class="text-sm"
                  >
                    {{ visibleMobileDate() ? (visibleMobileDate() | date: 'dd.MM.yy') : '—' }}
                  </span>
                }
                <proffeo-task-row-actions-menu
                  [task]="task()"
                  class="max-sm:flex! hidden!"
                />
              </div>
            </div>
          </div>

          <!--        USER AVATARY-->
          <div class="gap-1 items-center w-full hidden xl:flex">
            <proffeo-ui-task-assignees
              (changeIndustry)="industryClicked.emit(task())"
              (changeGroup)="changeGroupClicked.emit(task())"
              (changeUsers)="changeUsersClicked.emit(task())"
              (click)="$event.stopPropagation()"
              [projectIndustry]="task().projectIndustry()"
              [projectGroupAdmin]="task().projectGroupAdministrator()"
              [taskUsers]="taskUsers()"
              [avatarsOverlapping]="true"
              [avatarsLimit]="2"
            ></proffeo-ui-task-assignees>
          </div>

          <!--        BRANZA-->
          <div class="hidden md:flex items-center gap-1 w-full">
            <proffeo-task-industry-select
              (industryClicked)="onIndustryClicked(task())"
              [projectIndustry]="task().projectIndustry()"
              [isReadonly]="true"
              [isSmall]="true"
            ></proffeo-task-industry-select>
          </div>

          <!--        LOKACJA-->
          <div class="flex items-center w-full max-sm:hidden">
            <proffeo-location-select
              (locationClicked)="locationClicked.emit(task())"
              [isReadonly]="true"
              [location]="task().location()"
              class="w-full min-w-0"
            ></proffeo-location-select>
          </div>

          <!--        TIMER / ESTYMACJA-->
          <div class="flex items-center gap-1 w-full max-sm:hidden">
            <proffeo-task-timer
              [mode]="taskTimerMode.readonly"
              [summaryTime]="$safeNavigationMigration(task().statistics?.summaryTime)"
              [estimation]="$safeNavigationMigration(task().estimation?.time)"
            ></proffeo-task-timer>
          </div>

          <!--        PROGRESS-->
          <div class="flex items-center gap-1 w-full max-md:hidden">
            <span>{{ task().percentageOfProgress ?? 0 }} %</span>
          </div>

          <!--        START DATE-->
          <div class="flex items-center gap-1 w-full max-lg:hidden">
            <proffeo-ui-date-picker-compact
              (click)="$event.stopPropagation()"
              (valueChange)="emitTaskStartDateSelected($event)"
              [max]="task().endDate"
              [touchUi]="isMobile()"
              [value]="task().startDate"
              fontIcon="calendar_check"
              placeholderKey="project-tasks.list.column-headers.start-date"
              size="sm"
            />
          </div>

          <!--        END-DATE-->
          <div class="flex items-center gap-1 w-full max-lg:hidden">
            <proffeo-ui-date-picker-compact
              (click)="$event.stopPropagation()"
              (valueChange)="emitTaskEndDateSelected($event)"
              [min]="task().startDate"
              [touchUi]="isMobile()"
              [value]="task().endDate"
              fontIcon="calendar_add_on"
              placeholderKey="project-tasks.list.column-headers.end-date"
              size="sm"
            />
          </div>

          <div class="flex items-center max-sm:hidden">
            <proffeo-task-row-actions-menu [task]="task()" />
          </div>
        </div>
      </button>
    </div>

    @if (shouldRenderChildren()) {
      <!--      SUBTASKI TOGGLE-->
      <div class="flex flex-col gap-2 lg:gap-2 w-full">
        @for (sub of subtasks(); track sub.id) {
          <div class="flex w-full items-center">
            <proffeo-task-splitview-list-item
              [(expandedNodes)]="expandedNodes"
              (statusChanged)="statusChanged.emit($event)"
              (priorityChanged)="priorityChanged.emit($event)"
              (taskStartDateSelected)="taskStartDateSelected.emit($event)"
              (taskEndDateSelected)="taskEndDateSelected.emit($event)"
              (taskProgressSelected)="taskProgressSelected.emit($event)"
              (industryClicked)="industryClicked.emit($event)"
              (locationClicked)="locationClicked.emit($event)"
              (changeGroupClicked)="changeGroupClicked.emit($event)"
              (changeUsersClicked)="changeUsersClicked.emit($event)"
              [task]="sub"
              [isSubtask]="true"
              [subtaskDepth]="subtaskDepth() + 1"
              [compactMode]="false"
              [hasChildren]="(sub.subtasksCount ?? 0) > 0"
              [taskTypes]="taskTypes()"
              class="w-full"
            ></proffeo-task-splitview-list-item>
          </div>
        }
      </div>
    }
  </div>
}
